import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';

import ReactGA from 'react-ga4';

const Navigation = () => {
  const { oktaAuth, authState } = useOktaAuth();

  const login = useCallback(() => oktaAuth.signInWithRedirect(), [oktaAuth]);
  const logout = useCallback(() => oktaAuth.signOut(), [oktaAuth]);

  React.useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }, []);

  if (!authState) return null;

  const authNav = authState.isAuthenticated ? (
    <>
      <li className="nav-item">
        <Link className="nav-link font-weight-bold" to="/profile">Profile</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/feed/feedhome">Personalized RSS</Link>
      </li>
      <li className="nav-item">
        <button className="btn btn-link nav-link text-warning" onClick={logout}>Logout</button>
      </li>
    </>
  ) : (
    <>
      <li className="nav-item">
        <button className="btn btn-link nav-link" onClick={login}>Login</button>
      </li>
      <li className="nav-item">
        <Link className="nav-link text-warning font-weight-bold" to="/register">Register</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/feed/feedhome">RSS Feed</Link>
      </li>
    </>
  );

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top shadow-sm">
      <Link to="/" className="navbar-brand text-warning font-weight-bold">
          <img src="/favicon-32x32.png" alt={authState?.isAuthenticated ? "PCD Home" : "CD Home"} className="me-2" style={{ width: '24px', height: '24px', marginTop: '-4px' }} />
          {authState?.isAuthenticated ? 'PCD Home' : 'CD Home'}
      </Link>
      <ul className="navbar-nav ms-auto align-items-center">
        {authNav}
      </ul>
    </nav>
  );
};

export default Navigation;